import React from 'react';
import { motion } from 'framer-motion';
export function RevealSection() {
  return <section className="w-full bg-[#111827] py-12 md:py-20 px-4 relative" data-id="element-149">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-150"></div>

      <div className="max-w-3xl mx-auto space-y-8 md:space-y-16" data-id="element-151">
        {/* The Reveal */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-4 md:space-y-6 text-base md:text-xl text-[#f5f0e8]/90 leading-relaxed font-sans" data-id="element-152">
          <h2 className="font-serif text-xl md:text-3xl text-[#c9a84c] mb-4 md:mb-6" data-id="element-153">
            The Reveal
          </h2>
          <p data-id="element-154">
            While most investors are struggling with 7.5% mortgage rates, a
            small group of "Shadow Providers" is quietly controlling the most
            profitable micro-units in the Sun-Belt without owning a single
            brick.
          </p>
          <p className="font-bold text-white text-lg md:text-2xl" data-id="element-155">
            We don't buy the building. We control the{' '}
            <span className="text-[#c9a84c] underline decoration-[#c9a84c]/50 underline-offset-4" data-id="element-156">
              Cash-Flow Contract
            </span>{' '}
            inside it.
          </p>
        </motion.div>

        {/* The Unique Mechanism */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-[#0f1724] p-5 md:p-10 rounded-xl border border-[#c9a84c]/20 shadow-xl" data-id="element-157">
          <h3 className="font-serif text-xl md:text-3xl text-[#c9a84c] mb-4 md:mb-6" data-id="element-158">
            It's called The Shadow Rental Method.
          </h3>
          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-[#f5f0e8]/80" data-id="element-159">
            <p data-id="element-160">
              We target high-end corporate nomads, traveling nurses, and tech
              contractors who are flooding into Austin and Tampa. They can't
              sign a 12-month lease, and they hate cramped hotels.
            </p>

            <div className="py-6" data-id="element-161">
              <div className="bg-[#c9a84c]/10 border-l-4 border-[#c9a84c] p-4 md:p-6 rounded-r-lg" data-id="element-162">
                <p className="text-lg md:text-2xl font-bold text-white" data-id="element-163">
                  They pay a{' '}
                  <span className="text-[#c9a84c]" data-id="element-164">300% premium</span> for a
                  "Shadow Unit."
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}